<template>
  <div class="frequency-sum">
    <span>{{ title }} - {{ sum }} of {{ numberOfTargets }} calls</span>
    <span class="ml-2" :class="differenceClass">({{ valueDisplayFormat.percentages(difference) }} difference)</span>
  </div>
</template>

<script>
import { valueDisplayFormat } from '../../libraries/common';
export default {
  props: ['title', 'sum', 'numberOfTargets'],
  computed: {
    difference() {
      return this.sum / this.numberOfTargets - 1;
    },
    differenceClass() {
      return Math.abs(this.difference) > 0.05 ? 'alert-color' : '';
    },
    valueDisplayFormat() {
      return valueDisplayFormat;
    },
  },
}
</script>

<style lang="scss" scoped>
.frequency-sum {
  font-size: 18px;
}
.alert-color {
  color: red;
}
</style>